<template>
    <div>
        <div class="row m-t-b-sm" v-show="show_view">
            <div class="col-xs-12">
                <div class="row">
                    <div class="col-xs-6">
                        <input type="text" class="input input-md" name="verifyCode" placeholder="验证码" v-model.trim="verifyCode" required="required" autocomplete="off" @blur="validateCode()">
                    </div>
                    <div class=" col-xs-6 n-p-l ">
                        <button type="button " class="btn btn-primary btn-md col-xs-12" :disabled="reset.disabled" @click="sendCode()">{{reset.text}}</button>
                    </div>
                </div>
                <div class="row m-b-sm">
                    <div class="col-xs-12">
                        <div class="input-tips ">{{msg}}</div>
                    </div>
                </div>
                <div class="row ">
                    <div class="col-xs-12 ">
                        <button type="button " class="btn btn-primary btn-md col-xs-12 verify-btn" :disabled="validate.disabled" @click="completeVerify()">验证{{type_text}}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
const codeReg = /^[a-z0-9A-Z]{6}$/;
export default {
  props: {
    val: {
      type: String,
      default: ""
    },
    type: {
      // 类型 1 phone 2. email
      type: Number,
      default: 1,
      validator: function(val) {
        return val === 1 || val === 2;
      }
    }
  },
  data: function() {
    return {
      verifyCode: "",
      reset: {
        text: "发送验证码",
        disabled: false,
        timer: null,
        seconds: 60
      },
      validate: {
        disabled: false
      },
      msg: "",
      show_view: true
    };
  },
  computed: {
    type_text: function() {
      return this.type === 1 ? "手机" : "邮箱";
    }
  },
  watch: {
    val: function() {
      let that = this;
      that.show_view = true;
    }
  },
  methods: {
    validateCode: function() {
      let that = this;
      if (that.verifyCode == "") {
        that.validate.disabled = true;
        that.msg = "请输入验证码";
        return;
      }
      if (codeReg.test(that.verifyCode)) {
        that.msg = "";
        that.validate.disabled = false; // 注册按钮生效
      } else {
        that.msg = "请输入正确的验证码";
        that.validate.disabled = true;
      }
    },
    sendCode: function() {
      let that = this;
      that.reset.disabled = true; // 禁用按钮
      let _type = that.type === 1 ? "phone" : "email";
      that.$http
        .get(`/api/v1/users/${_type}_code?${_type}=${that.val}`)
        .then(res => {
          if (res.status === 200) {
            let data = res.body;
            if (data.code === 0) {
              // 校验成功
              that.reset.seconds = 60;
              that.reset.text = `剩余，${that.reset.seconds}s`;
              that.reset.timer = setInterval(() => {
                // 倒计时
                if (that.reset.seconds === 0) {
                  that.reset.disabled = false;
                  that.reset.text = `发送验证码`;
                  clearInterval(that.reset.timer);
                  that.reset.timer = null;
                } else {
                  that.reset.seconds--;
                  that.reset.text = `剩余，${that.reset.seconds}s`;
                }
              }, 1000);
            } else {
              that.reset.disabled = false;
              alert(data.msg);
            }
          } else {
            alert(`服务器繁忙，请稍后再重试验证(╯﹏╰）!!!`);
          }
        });
    },
    completeVerify: function() {
      let that = this;
      that.validate.disabled = true;
      let action = that.type === 1 ? "verify_phone" : "set_email";
      let options = {
        verifyCode: that.verifyCode
      };
      options[that.type === 1 ? "phone" : "email"] = that.val;
      that.$http.put(`/api/v1/users/${action}`, options).then(
        res => {
          if (res.status === 200) {
            let data = res.body;
            if (data.code === 0) {
              // 校验成功
              that.show_view = false;
              that.$emit("success", { type: that.type });
              alert("验证成功");
            } else {
              alert(data.msg);
            }
          } else {
            alert(`服务器繁忙，请稍后再重试验证(╯﹏╰）!!!`);
          }
          that.validate.disabled = false;
        },
        res => {
          that.validate.disabled = false;
          alert(`服务器繁忙，请稍后再重试验证(╯﹏╰）!!!`);
        }
      );
    }
  }
};
</script>
<style lang="less">
.verify-btn {
  letter-spacing: 5px;
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// verify-code.vue?78a593ce